import { useExperimentBucket } from '@carvana/experiment';
import TrackWrapper from '~/components/common/TrackWrapper';
import useIsInInspectionExperiment from '~/hooks/vdp/useIsInInspectionExperiment';
import ControlLowerSections, { OwnProps } from './ControlLowerSections';
import ExperimentLowerSections from './ExperimentLowerSections';

const EXPERIMENT = 'car-merch-ui-vdp-miu-miu-standards-and-150-inspection';

export default function LowerSections(props: OwnProps) {
  const isInInspectionExperiment = useIsInInspectionExperiment();
  const experimentBucket = useExperimentBucket(EXPERIMENT);

  const eventName = `${EXPERIMENT} ${experimentBucket} rendered`;

  return (
    <TrackWrapper
      element="div"
      delay={0}
      threshold={0}
      trackOnce
      event={{ eventName }}
    >
      {isInInspectionExperiment ? (
        <ExperimentLowerSections {...props} />
      ) : (
        <ControlLowerSections {...props} />
      )}
    </TrackWrapper>
  );
}
